import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import React from 'react';
import { useHistory } from 'react-router';

import { ReportedEmployeeItem } from '../../../../api/hs/dashboard/widget/widget.payload';
import { datePrettier } from '../../../../utils';

interface Props {
  users: ReportedEmployeeItem[];
}

export default ({ users }: Props) => {
  const history = useHistory();

  const handleClick = (employeeId: string) => {
    history.push(`/transactions/employee/${employeeId}/report`);
  };

  if (!users || users.length === 0) return <b>Kayıt bulunamadı!</b>;

  return (
    <TableContainer component={Paper}>
      <Table stickyHeader size="medium">
        <TableHead>
          <TableRow>
            <TableCell className="text-bold">Ad Soyad</TableCell>
            <TableCell className="text-bold">Başlangıç Tarihi</TableCell>
            <TableCell className="text-bold">Bitiş Tarihi</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {users.map((user: ReportedEmployeeItem) => (
            <TableRow key={user?.employeeId} hover onClick={() => handleClick(user.employeeId)}>
              <TableCell scope="row">{user.name}</TableCell>
              <TableCell>{datePrettier(user.startDate)}</TableCell>
              <TableCell>{datePrettier(user.endDate)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
